import React from 'react'

import ToggleMainMenuButton from './ToggleMainMenuButton'
import AccountInfo from './AccountInfo'
import TopMenu from './TopMenu'

import './MainToolbar.css'

type Props = {
  //
}

const MainToolbar: React.FC<Props> = () => (
  <nav className="navbar navbar-expand">
    <div className="container-fluid">
      <ToggleMainMenuButton />
      <AccountInfo />
      <TopMenu />
    </div>
  </nav>
)

export default MainToolbar
